module.exports = __webpack_public_path__ + "img/sa2.dc5cd00e.png";